import { render } from "./Dashboardpreviewsection.vue?vue&type=template&id=60af7c6f&scoped=true"
const script = {}

import "./Dashboardpreviewsection.vue?vue&type=style&index=0&id=60af7c6f&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60af7c6f"]])

export default __exports__